const typographyModalAction = {
  text: 'ADJUNTAR ARCHIVOS',
  true: 'Registrar Nueva Acción',
  false: 'Editar Acción'
};

export default typographyModalAction;
